import { render } from "./NewCar.vue?vue&type=template&id=0fbbf5c2&scoped=true"
import script from "./NewCar.vue?vue&type=script&lang=js"
export * from "./NewCar.vue?vue&type=script&lang=js"

import "./NewCar.vue?vue&type=style&index=0&id=0fbbf5c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbbf5c2"]])

export default __exports__